import { startPattern as assignTaskToPersonApi, getOperationPackageCountInProgress as getOperationPackageCountInProgressApi, getOperationPackages as getOperationPackagesApi } from '@/features/operation-packages/api';
import { useGetOperationPackageInstances as useGetOperationPackageInstancesCommon, useGetOperationPackagePatterns as useGetOperationPackagePatternsCommon, useGetOperationPackages as useGetOperationPackagesCommon, useGetOperationTaskCountInProgress as useGetOperationTaskCountInProgressCommon, usePostOperationPackagePatterns as usePostOperationPackagePatternsCommon } from '@/features/operation-packages/hooks';
const OWNER_PRODUCT = 'GA_OPERATION_CORE';

// --- API Wrappers ---

export const getOperationPackages = () => getOperationPackagesApi(OWNER_PRODUCT);
export const getOperationPackageCountInProgress = (id: string) => getOperationPackageCountInProgressApi(OWNER_PRODUCT, id);
export const assignTaskToPerson = (id: string, patternId: string, body: {
  targetPersonId: string;
  anchorDate: string;
}) => assignTaskToPersonApi(OWNER_PRODUCT, id, patternId, {
  targetPersonIds: [body.targetPersonId],
  anchorDate: body.anchorDate
});

// --- Hooks Wrappers ---

export const useGetOperationPackages = () => useGetOperationPackagesCommon(OWNER_PRODUCT);
export const useGetOperationPackagePatterns = (id: string, options?: {
  enabled?: boolean;
}) => useGetOperationPackagePatternsCommon(OWNER_PRODUCT, id, options);
export const usePostOperationPackagePatterns = (id: string, options?: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => usePostOperationPackagePatternsCommon(OWNER_PRODUCT, id, options);
export const useGetOperationTaskCountInProgress = (params: {
  operationPackageId: string;
  patternId: string;
}) => useGetOperationTaskCountInProgressCommon({
  ownerProduct: OWNER_PRODUCT,
  ...params
});
export const useGetOperationPackageInstances = (patternId: string, options?: {
  enabled?: boolean;
  page?: number;
  pageSize?: number;
  targetId?: string;
}) => useGetOperationPackageInstancesCommon(OWNER_PRODUCT, patternId, options);